import React from "react";

import style from "./style.module.css";

export default function Spacer({ size = "24" }) {
    return (
        <div className={`${style.spacer}${style["size" + size] ? ` ` + style["size" + size] : ''}`} />
    )
}